import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import CardGeneral from './card-general'
import { Check } from 'react-feather'
import MadeInUSA from '../assets/icons/madeinusa'

const WhyUsUnorderedList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  position: relative;

  li {
    list-style-type: none;
    padding: 0;
    padding-left: 25px;
    line-height: 1.4;
    position: relative;
    svg {
      border-radius: 50%;
      padding-top: 5px;
      stroke-width: 4px;
      stroke: #fff;
      margin-left: -35px;
      padding: 4px;
      position: absolute;
      top: 2px;
    }
  }
`
const MadeInTheUSALogo = styled.div`
  margin-top: -10px;
  margin-bottom: 15px;
`

const WhyUs = () => (
  <StaticQuery
    query={graphql`
      query WhyUsListQuery {
        site {
          siteMetadata {
            whyUs
          }
        }
      }
    `}
    render={data => {
      return (
        <>
          <CardGeneral title={'Why Us'} className={'theme-primary'}>
            {/* <MadeInTheUSALogo>
       
       <MadeInUSA/>
        </MadeInTheUSALogo> */}
            <WhyUsUnorderedList className="whyuslist">
              <li>
                {' '}
                <Check
                  size={22}
                  className="bg-color-primary stroke-color-primary-lightest"
                />
                Full-Service, Start to Finish
                <p>Everything You Need Under One Roof</p>
              </li>

              <li>
                {' '}
                <Check
                  size={22}
                  className="bg-color-primary stroke-color-primary-lightest"
                />
                We Handle The Plans &amp; Permits
                <p>To Ensure Quality, Professionalism, and Competence</p>
              </li>
              <li>
                <Check
                  size={22}
                  className="bg-color-primary stroke-color-primary-lightest"
                />{' '}
                Local, Family-Owned &amp; Operated
                <p>Decades of Combined Experience</p>
              </li>
              <li>
                <Check
                  size={22}
                  className="bg-color-primary stroke-color-primary-lightest"
                />
                Free Estimates, Competitive Pricing
                <p>Get Detailed Project Cost / Quote</p>
              </li>
              <li>
                <Check
                  size={22}
                  className="bg-color-primary stroke-color-primary-lightest"
                />{' '}
                All Inclusive / Full Responsibility
                <p>One-Stop Shopping Experience</p>
              </li>
              <li>
                <Check
                  size={22}
                  className="bg-color-primary stroke-color-primary-lightest"
                />{' '}
                A+ Better Business Bureau Rating
                <p>Dedicated to Excellent Service</p>
              </li>
              <li className="nobm">
                <Check
                  size={22}
                  className="bg-color-primary stroke-color-primary-lightest"
                />{' '}
                Combo, Senior &amp; Military Discounts
                <p>Save Money on Your Home Renovation</p>
              </li>
            </WhyUsUnorderedList>
          </CardGeneral>
        </>
      )
    }}
  />
)

export default WhyUs
